// Arrow button scroll
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.br-prod-slider-btn');
  if (!btn) return;

  const slider = document.getElementById(btn.dataset.target);
  if (!slider) return;

  const itemWidth = slider.querySelector('.br-prod-simple__item')?.offsetWidth ?? 0;
  const gap = 20;
  const scrollAmount = (itemWidth + gap) * 2;

  slider.scrollBy({ left: btn.dataset.dir === 'prev' ? -scrollAmount : scrollAmount, behavior: 'smooth' });
});

// Drag-to-scroll on PC
document.querySelectorAll('.br-prod-simple').forEach(initDragScroll);

function initDragScroll(slider) {
  let startX = 0;
  let startScrollLeft = 0;
  let isDragging = false;

  slider.addEventListener('mousedown', (e) => {
    isDragging = true;
    startX = e.pageX;
    startScrollLeft = slider.scrollLeft;
    slider.classList.add('is-dragging');
  });

  document.addEventListener('mousemove', (e) => {
    if (!isDragging) return;
    slider.scrollLeft = startScrollLeft - (e.pageX - startX);
  });

  document.addEventListener('mouseup', () => {
    if (!isDragging) return;
    isDragging = false;
    slider.classList.remove('is-dragging');
  });

  // Prevent link clicks after drag
  slider.addEventListener('click', (e) => {
    if (Math.abs(slider.scrollLeft - startScrollLeft) > 4) {
      e.preventDefault();
    }
  }, true);
}
